import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * DataVisualizationLibraryPanel component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    DVLibraryPanel: {
      height: '100%',
    },

    header: {
      marginBottom: '2.4rem',
      display: 'flex',
    },

    search: {
      marginRight: '.8rem',
      width: '100%',
      '& div > div': {
        borderColor: `${variables.colorV2.input.search.border.default} !important`,
      },
      '& input': {
        fontSize: '1.3rem',
        height: '2.6rem',
        lineHeight: '1.8rem',
        padding: '.1rem 0',
      },
    },

    uploadBtn: {
      borderRadius: '.8rem',
      // border: `0.1rem solid ${variables.colorV2.button.alternate.border.default}`,
      padding: '.5rem .5rem',
      '&:hover': {
        // border: `1px solid ${variables.color.primary.mainPurple}`,
      },
      '&:hover svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.hover,
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      height: 'calc(100% - 4.9rem)',
      overflowY: 'auto',
      // marginRight: theme.spacing(-1.25),
      paddingRight: '.5rem',

      '& .infinite-scroll-component': {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.6rem',
      },
    },

    imageWrapper: {
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      border: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.listing}`,
      borderRadius: '.8rem',

      '&[data-chosen=true]': {
        border: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.active} !important`,
      },

      '&:hover': {
        border: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.hover} !important`,
      },
    },

    image: {
      backgroundColor: variables.colorV2.panel.background.default,
      backgroundPosition: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      borderBottom: `.1rem solid ${variables.colorV2.contentModuleCard.default.border.listing}`,
      borderRadius: '.8rem .8rem 0 0',
      height: '16.3rem',
    },

    moduleRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    name: {
      color: variables.colorV2.contentModuleCard.default.text.default,
      marginBottom: theme.spacing(0.5),
    },

    imageContent: {
      padding: theme.spacing(1, 2, 2, 2),
    },

    index: {
      '&&': {
        color: variables.colorV2.contentModuleCard.default.text.default,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        background: variables.colorV2.contentModuleCard.default.background.id,
        borderRadius: '2px',
        width: 'fit-content',
        padding: '2px 5px',
        fontWeight: '700',
        fontSize: '9px',
        cursor: 'pointer',
      },
    },

    loaderBlock: {
      marginBottom: '20px',
    },

    searchBar: {
      marginBottom: '2.4rem',
    },

    sfsuContainer: {
      '&&': {
        gap: '0.8rem',
        width: '100%',
      },
    },

    sfsuSearchBar: {
      '&&': {
        height: '2.8rem',
        marginLeft: '0',
        width: '100%',
        zIndex: 1,
        '& input': {
          height: '2.6rem',
        },
      },
      '& > div > div': {
        borderColor: variables.colorV2.input.search.border.default + ' !important',
      },
    },

    sfsuUploadButton: {
      marginLeft: 0,
      minWidth: '2.6rem',
      width: '2.6rem',
      padding: '0.5rem 0.5rem',
      '& svg': {
        height: '1.6rem',
        width: '1.6rem',
      },
    },
  }),
);
